// Clickable citation pill. Appears inline in Ask answers and in the
// citation rows of Compare answers. Clicking opens the PDF drawer at the
// cited page.

import './Citation.css';

export interface CitationRef {
  party: 'PL' | 'PN';
  page: number;
  chapter: string | null; // PN only — PN page numbers reset per chapter
}

// Matches both the bracketed inline form ([PL p.42], [PN: Ekonomija, p.8])
// and the bare form used in Compare-mode citation arrays (PL p.5,
// PN: Ekonomija, p.8). Tolerant of optional spaces and page ranges
// (PL p.87-91 → opens at the first page).
const CITATION_RE =
  /^\[?\s*PL\s*p\.?\s*(\d+)(?:\s*[-–]\s*\d+)?\s*\]?$|^\[?\s*PN:\s*([^,\]]+?)\s*,\s*p\.?\s*(\d+)(?:\s*[-–]\s*\d+)?\s*\]?$/i;

export function parseCitationRef(raw: string): CitationRef | null {
  const m = raw.trim().match(CITATION_RE);
  if (!m) return null;
  if (m[1]) {
    return { party: 'PL', page: parseInt(m[1], 10), chapter: null };
  }
  if (m[2] && m[3]) {
    return { party: 'PN', page: parseInt(m[3], 10), chapter: m[2].trim() };
  }
  return null;
}

export function citationLabel(c: CitationRef): string {
  return c.party === 'PL'
    ? `PL p.${c.page}`
    : `PN · ${c.chapter ?? '?'} p.${c.page}`;
}

export default function Citation({
  cite,
  onOpen,
}: {
  cite: CitationRef;
  onOpen: (c: CitationRef) => void;
}) {
  return (
    <button
      type="button"
      className={`mf-cite mf-cite--${cite.party.toLowerCase()}`}
      onClick={() => onOpen(cite)}
      title={`Open ${citationLabel(cite)} in the manifesto`}
    >
      {citationLabel(cite)}
    </button>
  );
}
